
    import Vue from "vue";
    import Component from "vue-class-component";
    import LandingpageIllustration from "@/components/LandingpageIllustration.vue";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import {AvailableProfileModel, factory, ResultError, SeafarersClient} from "@/api-client";
    import {authService} from "@/AuthService";
    import {Prop} from "vue-property-decorator";
    import Loader from "@/features/shared/components/Loader";
    import LoadingSpinner from "@/components/LoadingSpinner.vue";
    import CardQuicklink from "@/features/dashboard/components/CardQuicklink.vue";
    import {NavigationGuardNext} from "vue-router/types/router";
    import ErrorsSummary from "@/components/ErrorsSummary.vue";
    import { confirmPersonalDataRouteName } from "@/router";

    interface Props {
        availableProfiles: AvailableProfileModel[];
    }

    @Component({
        components: {
            ErrorsSummary,
            ValidationErrorsSummary: ErrorsSummary,
            LandingpageIllustration,
            SectionPageHeading,
            LoadingSpinner,
            CardQuicklink
        },
        beforeRouteEnter(to, from, next: NavigationGuardNext<ProfileSelection>) {
            const props = to.meta!.props as Props;
            if (authService.availableProfiles.length == 1 && (authService.availableProfiles[0].isSeafarer || authService.availableProfiles[0].isAccessLinkUser)) {
                authService.selectProfile(authService.availableProfiles[0]).then(landingPageRouteName => {
                    next(to.query.returnUrl !== "/" ? to.query.returnUrl as string : { name: landingPageRouteName });
                });
            } else {
                props.availableProfiles = authService.availableProfiles;
                next();
            }
        }
    })
    export default class ProfileSelection extends Vue implements Props {
        @Prop({ required: true })
        availableProfiles!: AvailableProfileModel[];

        alreadyHasSeafarerProfile = false;
        errors = factory.create(ResultError);
        loader = new Loader();

        async created() {
          if (!authService.isLoggedIn)
            await this.$router.push({ name: "Home" });
        }


        async selectProfile(profile: AvailableProfileModel) {
            const landingPageRouteName = await authService.selectProfile(profile);
            if(authService.confirmData){
                await this.$router.push({
                    name: confirmPersonalDataRouteName,
                    query: { returnUrl: this.$route.query.returnUrl !== undefined && this.$route.query.returnUrl !== "/" ? this.$route.query.returnUrl as string : this.$router.resolve({ name: landingPageRouteName }).href },
                });
            }
            else
            {
                await this.$router.push(this.$route.query.returnUrl !== undefined && this.$route.query.returnUrl !== "/" ? this.$route.query.returnUrl as string : { name: landingPageRouteName });
            }
        }

        get canBecomeSeafarer(): boolean {
            return !this.availableProfiles.find(profile => profile.isSeafarer);
        }
    }
